import { buildSlottedStyles, getCss, getImageStyleJssStyle, getObjectFitJssStyle, getRatioJssStyle, } from "../../utils";
export const createStyles = () => {
    return getCss({
        '@global': {
            ':host': {
                display: 'block',
            },
        },
    });
};
export const getSlottedCss = (el, ratio, imageStyle, objectFit) => {
    return getCss(buildSlottedStyles(el, {
        '& img': Object.assign(Object.assign(Object.assign({ display: 'block', width: '100%', height: 'auto' }, getRatioJssStyle(ratio)), getObjectFitJssStyle(objectFit)), getImageStyleJssStyle(imageStyle)),
    }));
};
//# sourceMappingURL=image-styles.js.map
